import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CountryItem from '../../../Domain/CountryItem';
import CountryService from '../../../Services/CountryService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for countries. Single page
// with >6 fields renders as the full-screen DS wizard modal (no section nav).
export default class CountryWindowDescription {
  static titleForCreate = 'Create a new country';
  static titleForEdit = 'Edit country';
  static entityName = 'Country';
  static idField = 'CountryId';
  static nameField = 'Name';
  static itemType = CountryItem;
  static serviceFunction = CountryService.UpsertCountry;
  static messageOnSuccess = 'Country has been saved.';
  static finishButtonLabel = 'Save';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Country Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Code',
          label: 'Code',
          className: 'col-2',
          type: InputTypesEnum.Text,
          validityChecker: (value) => CountryWindowDescription.forTextLenghtCheck(value),
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-4',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        { fieldName: 'OfficeId', label: 'Sales/FW Office', className: 'col-6', type: InputTypesEnum.OfficeSelect },
        {
          fieldName: 'EvaluatorOfficeId',
          label: 'Evaluator Payment Office',
          className: 'col-6',
          type: InputTypesEnum.OfficeSelect,
        },
        {
          fieldName: 'EvaluatorCurrencyId',
          label: 'Evaluator Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
        },
        {
          fieldName: 'LocalCurrencyId',
          label: 'Local Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
        },
        { fieldName: 'Idc', label: 'IDC', className: 'col-6', type: InputTypesEnum.Text },
      ],
    },
  ];

  static forTextLenghtCheck(e) {
    if (e === undefined || e.length !== 2 || !e.match(/^[A-Za-z]+$/)) return `Must be ${2} letters`;
    return '';
  }
}
